import * as React from 'react';
import { Page } from '../../components/Page';
import { ContentSection } from '../../components/ContentSection';
import { PaginationContainer } from '../PaginationContainer';
import { TitleContainer } from '../TitleContainer';
import { BuildersListingContainer } from '../BuildersListingContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { Responsive } from '@cian/ui-kit';

export function PageContainer() {
  return (
    <>
      <Page>
        <ContentSection>
          <BreadcrumbsContainer placement="header" />
          <TitleContainer />
          <BuildersListingContainer />
          <PaginationContainer />
        </ContentSection>
      </Page>
      <Responsive phone>
        <BreadcrumbsContainer placement="footer" />
      </Responsive>
    </>
  );
}
